import React from 'react';
import { useTheme } from '../ThemeContext';
import { isNativeApp } from '../utils/platform';
import { declineBody, firstName, START_OWN_ACCOUNT_LABEL, waitingCopy } from '../shared/friendInvite';
import { ASK_YOUR_SPONSOR_TEXT, nativeOwnAccountAllowed } from '../shared/nativeSignupCopy';

const filledButton = {
  width: '100%',
  minHeight: '48px',
  border: 'none',
  borderRadius: '12px',
  background: '#59c4c4',
  color: '#083838',
  fontWeight: 700,
  fontSize: '1rem',
  cursor: 'pointer',
};

const quietButton = {
  width: '100%',
  minHeight: '44px',
  border: 'none',
  background: 'transparent',
  color: '#0f766e',
  fontWeight: 650,
  fontSize: '1rem',
  cursor: 'pointer',
};

export default function FriendStatus({ status, agentFirstName, native, onStartOwn }) {
  const { colors, isDark } = useTheme();
  const onDevice = native === undefined ? isNativeApp() : native === true;
  const allowOwn = nativeOwnAccountAllowed(onDevice);
  const declined = status === 'declined';
  const who = firstName(agentFirstName, 'Your sponsor');
  const body = declined ? declineBody(who, allowOwn ? undefined : { ownAccount: false }) : waitingCopy(who);
  return (
    <section
      data-testid={declined ? 'friend-join-declined' : 'friend-join-pending'}
      style={{
        background: colors.surface,
        color: colors.text,
        border: `1px solid ${colors.border}`,
        borderRadius: '16px',
        padding: '1.1rem 1.15rem',
      }}
    >
      <p style={{ margin: '0 0 0.85rem', fontSize: '1.05rem', lineHeight: 1.5 }}>{body}</p>
      {declined && !allowOwn ? (
        <p data-testid="native-ask-sponsor" style={{ margin: 0, fontSize: '1.05rem', lineHeight: 1.5, fontWeight: 650 }}>
          {ASK_YOUR_SPONSOR_TEXT}
        </p>
      ) : null}
      {allowOwn ? (
        <button
          type="button"
          onClick={() => {
            if (typeof onStartOwn === 'function') onStartOwn();
          }}
          style={declined ? filledButton : { ...quietButton, color: isDark ? '#5eead4' : '#0f766e' }}
        >
          {START_OWN_ACCOUNT_LABEL}
        </button>
      ) : null}
    </section>
  );
}
